import React, { useEffect, useRef } from 'react';
import { AlertCircle, Clock, Volume2, Utensils } from 'lucide-react';
export function Problem() {
  const sectionRef = useRef<HTMLElement>(null);
  const hasTracked = useRef(false);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !hasTracked.current) {
          try {
            if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
              window.fbq('trackCustom', 'ViewProblemSection', {
                section: 'Problem Identification'
              });
              console.log('✅ ViewProblemSection event tracked');
              hasTracked.current = true;
            }
          } catch (error) {
            console.error('❌ Error tracking problem section view:', error);
          }
        }
      });
    }, {
      threshold: 0.5
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => observer.disconnect();
  }, []);
  return <section ref={sectionRef} className="py-10 bg-white" id="problema" data-id="element-418">
      <div className="container mx-auto px-4 md:px-6" data-id="element-419">
        <div className="max-w-3xl mx-auto" data-id="element-420">
          <div className="flex items-center gap-3 mb-6 justify-center" data-id="element-421">
            <AlertCircle size={28} className="text-amber-700" data-id="element-422" />
            <h2 className="text-2xl md:text-3xl font-bold text-amber-900 font-serif" data-id="element-423">
              El problema real
            </h2>
          </div>
          <p className="text-amber-800 mb-6 text-center" data-id="element-424">
            No es que tu hijo "no te haga caso" o que tú "no tengas paciencia".
            El problema es que las rutinas familiares actuales no tienen:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-425">
            <div className="bg-amber-50 p-4 rounded-lg border border-amber-100 flex gap-3" data-id="element-426">
              <Clock size={20} className="text-amber-700 flex-shrink-0" data-id="element-427" />
              <div data-id="element-428">
                <h4 className="font-medium text-amber-900 mb-1" data-id="element-429">
                  Estructura visual
                </h4>
                <p className="text-sm text-amber-800" data-id="element-430">
                  Los niños necesitan ver los pasos, no solo escucharlos
                </p>
              </div>
            </div>
            <div className="bg-amber-50 p-4 rounded-lg border border-amber-100 flex gap-3" data-id="element-431">
              <Volume2 size={20} className="text-amber-700 flex-shrink-0" data-id="element-432" />
              <div data-id="element-433">
                <h4 className="font-medium text-amber-900 mb-1" data-id="element-434">
                  Límites claros y consistentes
                </h4>
                <p className="text-sm text-amber-800" data-id="element-435">
                  Sin gritos, pero con firmeza y seguimiento
                </p>
              </div>
            </div>
            <div className="bg-amber-50 p-4 rounded-lg border border-amber-100 flex gap-3" data-id="element-436">
              <Utensils size={20} className="text-amber-700 flex-shrink-0" data-id="element-437" />
              <div data-id="element-438">
                <h4 className="font-medium text-amber-900 mb-1" data-id="element-439">
                  Soluciones prácticas
                </h4>
                <p className="text-sm text-amber-800" data-id="element-440">
                  Cenas rápidas, transiciones suaves, menos negociación
                </p>
              </div>
            </div>
            <div className="bg-amber-50 p-4 rounded-lg border border-amber-100 flex gap-3" data-id="element-441">
              <AlertCircle size={20} className="text-amber-700 flex-shrink-0" data-id="element-442" />
              <div data-id="element-443">
                <h4 className="font-medium text-amber-900 mb-1" data-id="element-444">
                  Plan de implementación
                </h4>
                <p className="text-sm text-amber-800" data-id="element-445">
                  Paso a paso, sin abrumar ni adivinar
                </p>
              </div>
            </div>
          </div>
          <div className="mt-8 bg-amber-100 border border-amber-200 rounded-lg p-4" data-id="element-446">
            <p className="text-amber-900 text-center" data-id="element-447">
              <strong data-id="element-448">Resultado:</strong> Repites 10 veces, gritas, sientes
              culpa… y mañana vuelves a empezar desde cero.
            </p>
          </div>
        </div>
      </div>
    </section>;
}